import {dom, library} from '@fortawesome/fontawesome-svg-core'

// import the needed icons here
import {
  faBolt,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleXmark,
  faCloudRain,
  faDroplet,
  faEye,
  faLineChart,
  faPrint,
  faSackDollar,
  faSeedling,
  faVial,
  faWheatAwn,
  faBook,
} from '@fortawesome/free-solid-svg-icons'

import {
  faAtomSimple,
  faCircleBolt,
  faCloudExclamation,
  faEnvelope,
  faHandHoldingSeedling,
  faPlateUtensils,
} from '@fortawesome/pro-solid-svg-icons'
import {
  faFacebook,
  faFacebookSquare,
  faLinkedin,
  faTwitter,
  faWhatsappSquare,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'

// Add the icons you imported here
library.add(
  faAtomSimple,
  faBolt,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faCloudRain,
  faCloudExclamation,
  faCloudRain,
  faCircleBolt,
  faCircleXmark,
  faDroplet,
  faEye,
  faHandHoldingSeedling,
  faLineChart,
  faPlateUtensils,
  faPrint,
  faSackDollar,
  faSeedling,
  faVial,
  faWheatAwn,
  faWhatsappSquare,
  faFacebookSquare,
  faFacebook,
  faYoutube,
  faLinkedin,
  faTwitter,
  faEnvelope,
  faBook,
)

dom.watch()

// More info here: https://discourse.roots.io/t/how-to-use-font-awesome-5-in-your-sage-theme/11737
